import css from './Landing.module.scss'

const Landing = ({ buttonHandler, buttonText }) => {
  const { description, logo, splash, payoff } = window.runConfig
  return (
    <div className={`${css.Landing} landing`}>
      {logo && (
        <div className='li_logo'>
          <img src={logo} alt='logo' className='logo' />
        </div>
      )}
      <ul className={css.UlLanding}>
        {splash && (
          <li className='li_splash'>
            <img src={splash} alt='splash' className={'splash'} />
          </li>
        )}
        {payoff && <li className='li_payoff'>{payoff}</li>}
        {description && <li className='li_description'>{description}</li>}
        <li className='li_button'>
          <button
            onClick={buttonHandler}
            className='enable-button'
            type='button'
          >
            {buttonText || 'Enable Camera'}
          </button>
        </li>
      </ul>
    </div>
  )
}

export default Landing
